package com.dignicate.web.domain

// ドメインモデル: Footer の構造を定義

enum class LinkKind {
    Internal,
    External
}

enum class FooterItemKey {
    About,
    TermsOfService,
    PrivacyPolicy,
    Careers,
    Architecture,
    CaseStudies,
    GitHub
}

data class FooterItem(
    val key: FooterItemKey? = null,
    val label: String,
    val href: String?,
    val kind: LinkKind = LinkKind.Internal
)

data class FooterColumn(
    val title: String,
    val items: List<FooterItem>
)

data class FooterNav(
    val columns: List<FooterColumn>
)

interface FooterNavRepository {
    fun getFooterNav(): FooterNav
}
